import React from 'react';
import { FolderOpen } from 'lucide-react';

const ProjectSelector = ({ projects, onSelect, userRole }) => {
  return (
    <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
      <div className="text-center mb-6">
        <FolderOpen className="w-16 h-16 text-indigo-600 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Select a Project</h2>
        <p className="text-gray-600">
          {userRole === 'superadmin' 
            ? 'Choose a project to manage' 
            : 'Please select the project you want to work with'}
        </p>
      </div>
      
      <div className="space-y-3">
        {projects.map((project) => (
          <button
            key={project.id}
            onClick={() => onSelect(project)}
            className="w-full p-4 text-left border-2 border-gray-200 rounded-lg hover:border-indigo-500 hover:bg-indigo-50 transition-all"
          >
            <div className="font-semibold text-gray-800">{project.name}</div>
            {project.description && (
              <div className="text-sm text-gray-600 mt-1">{project.description}</div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProjectSelector;

